import { ref } from 'vue'
import type { BillingProduct } from '@/features/system-settings/types/system-settings'

export interface PendingCheckout {
  organizationId: number
  product: BillingProduct
}

const STORAGE_KEY = 'moose:pending-checkout'

/** A checkout the provider just reported as finished, whose webhook may still be on its way. */
export const completedCheckout = ref<PendingCheckout | null>(null)

/** Survives the full page navigation to the provider and back. */
export function rememberCheckout(checkout: PendingCheckout): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(checkout))
  } catch {
    // Storage unavailable: the subscription just shows up on the next reload.
  }
}

export function forgetCheckout(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Storage unavailable: nothing was remembered.
  }
}

function readCheckout(): PendingCheckout | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)

    return stored ? (JSON.parse(stored) as PendingCheckout) : null
  } catch {
    return null
  }
}

/** Called when the provider returns from a successful checkout. */
export function confirmCheckout(): void {
  completedCheckout.value = readCheckout()
  forgetCheckout()
}
